module.exports = __webpack_public_path__ + "img/backs_logo.34e7aa1a.svg";